import { createSelector, createFeatureSelector } from '@ngrx/store';

import { DevAuthModuleState } from '../../models/dev-auth.model';

export const getDevAuthModuleState = createFeatureSelector<DevAuthModuleState>('devAuthModule');

export const getDevAuthResponse = createSelector(getDevAuthModuleState, (state) => state);
